import React from "react";

export default function DashboardNav({ 
  subscription, 
  merchantInfo, 
  fetchRules, 
  checkSubscription, 
  navigate, 
  handleLogout 
}) {
  return (
    <>
      {/* TOP MAIN NAVIGATION BAR */}
      <nav className="premium-nav">
        <div className="nav-logo-side">
          <span style={{ fontSize: "22px" }}>📊</span>
          <span className="nav-brand">Count My Visit Workspace</span>
        </div>
        <div className="nav-actions">
          <button className="nav-btn btn-secondary-nav" onClick={() => { fetchRules(); checkSubscription(); }}>
            🔄 Refresh Data
          </button>
          <button className="nav-btn btn-primary-nav" onClick={() => navigate("/MerchantQRScreen")}>
            📱 Download Shop QR
          </button>
          <button className="nav-btn btn-primary-nav" onClick={() => navigate("/merchantanalytics")}>
            💬 Reviews
          </button>
          <button className="nav-btn btn-primary-nav" onClick={() => navigate("/MerchantSubs")}>
            ⚡ Renew plan
          </button>
          <button className="nav-btn btn-primary-nav" onClick={() => navigate("/MerchantScannerScreen")}>
            🔍 Add Visit by Scan
          </button>
          <button className="nav-btn btn-primary-nav" onClick={() => navigate("/MerchantScanner")}>
            🔍 Redeem voucher by scan
          </button>
          <button className="nav-btn btn-danger-nav" onClick={handleLogout}>
            🚪 Logout
          </button>
        </div>
      </nav>

      {/* SUBSCRIPTION PANEL STATUS */}
      {subscription.loaded && (
        subscription.active ? (
          <div className="sub-status-bar sub-active-bar">
            <span>Verified Merchant Profile ✔️ Account Status: Active ({subscription.planName || "Premium"})</span>
            <span className="sub-days-count">⏳ {subscription.daysLeft} Days Remaining</span>
          </div>
        ) : (
          <div className="sub-status-bar sub-expired-bar">
            <span>⚠️ Gateway Warning: Subscription Campaign Expired! Please renew to reactivate parameters mapping.</span>
            <button className="sub-renew-btn" onClick={() => navigate("/MerchantSubs")}>⚡ Renew Platform</button>
          </div>
        )
      )}

      {/* WORKSPACE DETAILS HEADER */}
      <div className="top-header">
        <div>
          {merchantInfo ? (
            <>
              <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                <h1 className="merchant-title">{merchantInfo.business_name || "Merchant Business Workspace"}</h1>
                <span className="badge" style={{ background: "#e0f2fe", color: "#0369a1" }}>
                  {merchantInfo.business_type || "Retailer Store"}
                </span>
              </div>
              <p style={{ color: "#64748b", fontSize: "13px", marginTop: "4px" }}>
                Operator: <strong style={{ color: "#0f172a" }}>{merchantInfo.owner_name}</strong> | 📍 {merchantInfo.address || "Active Branch Network"}
              </p>
            </>
          ) : (
            <>
              <h1 style={{ fontSize: "24px", fontWeight: "800", color: "#0f172a" }}>Syncing Core Workspace Controls...</h1>
              <p style={{ color: "#64748b", fontSize: "13px" }}>Connecting securely to remote relational schemas data models.</p>
            </>
          )}
        </div>
        <div className="merchant-logo">
          {merchantInfo?.business_name ? merchantInfo.business_name.charAt(0).toUpperCase() : "🏪"}
        </div>
      </div>
    </>
  );
}